var getHeight = require('../functions/get-height'),
	slide = function(obj, callback)  {
		var objHeight = obj.offsetHeight,
			startingHeight,
			animateHeight,
			endingDisplay;

		if (objHeight == 0) {
			startingHeight = 0;
			animateHeight = getHeight(obj);
			endingDisplay = 'block';
		} else {
			startingHeight = objHeight;
			animateHeight = 0;
			endingDisplay = 'none';
		}

		obj.style.height = `${startingHeight}px`;
		obj.style['transition'] = 'height 0.3s ease-out';
		obj.style.overflow = 'hidden';
		obj.style.display = 'block';
		obj.style.paddingBottom = 0;
		obj.style.paddingTop = 0;

		setTimeout(function() {
			obj.style.height = `${animateHeight}px`;
		}, 30);
		setTimeout(function() {
			obj.removeAttribute('style');
			obj.style.display = endingDisplay;

			if (callback) {
				callback();
			}
		}, 300);
	};

module.exports = slide;